module.exports = __webpack_public_path__ + "img/贝类.660babbc.png";